export default "__VITE_ASSET__Dpz2HRld__"